import React, { Fragment } from "react";
import FeedbackCard from "./FeedbackCard";
import CardDeck from "react-bootstrap/CardDeck";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const FeedbackList = ({ feedback, drivers, searchDriver }) => {
  const [driver, setDriver] = React.useState(false);
  const createOptions = () =>
    drivers.map((data) => (
      <option key={data.id} value={data.id}>
        {data.first_name}
      </option>
    ));
  const handleInputChange = React.useCallback((event) => {
    const target = event.target;
    const value = target.value === "All drivers" ? false : target.value;
    const name = target.name;
    searchDriver(value);
    setDriver(value);
  }, []);
  // const filteredFeedback = driver
  //   ? feedback.filter((feed) => feed.driver_id == driver)
  //   : feedback;

  return (
    <Fragment>
      <Form className="d-inline-flex mt-15 " onSubmit={this.handleConfirm}>
        <Form.Row>
          <Form.Group controlId="formDrivers">
            <Form.Label></Form.Label>
            <Form.Control
              name="driver"
              onChange={handleInputChange}
              value={driver}
              as="select"
            >
              <option>All drivers</option>
              {createOptions()}
            </Form.Control>
          </Form.Group>
        </Form.Row>
      </Form>
      <CardDeck style={{ flex: "none" }}>
        {feedback.map((feed, i) => {
          const driverProp = drivers.find(
            (driv) => driv.id === feedback[i].driver_id
          );
          return (
            <FeedbackCard
              key={i}
              id={feedback[i].id}
              order_id={feedback[i].order_id}
              customer_name={feedback[i].shipto_first_name}
              merchant={feedback[i].shipfrom_name}
              date={feedback[i].date}
              feedback={feedback[i].feedback}
              driver={driverProp.first_name}
              rating_driver={feedback[i].rating_driver}
              rating_mile1={feedback[i].rating_mile1}
            />
          );
        })}
      </CardDeck>
    </Fragment>
  );
};

export default FeedbackList;
